import type { Fallacy } from "./types";
import { createStory } from "./types";

export const framingEffect: Fallacy = {
    id: "framing-effect",
    name: "Framing Effect",
    emoji: "🖼️",
    category: "Otak yang Menipu Diri",
    description: "Reaksi kita berubah tergantung **cara informasi disajikan**, meskipun **faktanya sama**.",
    tldr: "\"Berhasil 90%\" vs \"gagal 10%\" — fakta sama, tapi reaksi beda.",
    detail: "Framing Effect adalah bias kognitif di mana keputusan seseorang **dipengaruhi oleh cara informasi disajikan**, bukan oleh informasi itu sendiri. **Fakta yang sama bisa memicu reaksi yang sangat berbeda** tergantung apakah disajikan secara positif atau negatif.\n\nContoh klasik: \"Operasi ini tingkat keberhasilan 90%\" vs \"tingkat kegagalan 10%\" — **fakta identik**, tapi reaksi orang sangat berbeda.\n\nDi dunia marketing dan politik, framing effect dimanfaatkan secara masif. Politisi menyebut kebijakan \"perlindungan keamanan\" vs \"pembatasan kebebasan\" — **framing berbeda menghasilkan dukungan publik yang berbeda**.\n\nCara melawan: Selalu cari **data mentahnya**. Terjemahkan framing positif ke negatif dan sebaliknya — kalau keputusan kamu berubah, berarti kamu terjebak framing effect.",
    story: createStory("Framing Effect", "🖼️", {
      hook: {
        title: "Mana yang kamu pilih?",
        body: "\"Berhasil 90%\" atau \"gagal 10%\"? Fakta sama persis — tapi pasti kamu pilih yang pertama kan?",
      },
      convo: {
        claim: "Daging ini bagus banget, di kemasannya tertulis **90% bebas lemak**. Jelas lebih sehat dibanding yang lain.",
        response: "Itu artinya 10% lemak. **Fakta sama, bungkusnya doang yang beda.**",
      },
      reveal: {
        body: "Keputusan kamu **berubah tergantung cara informasi dikemas**, bukan isi informasinya. Fakta yang sama bisa terasa beda banget cuma gara-gara bungkusnya.",
      },
      insight: {
        title: "Triknya simpel:",
        body: "**Balik framing-nya.** \"90% berhasil\" jadi \"10% gagal\". Kalau keputusan kamu berubah cuma gara-gara cara nyebutnya beda, berarti kamu lagi ke-frame.",
      },
      engagement: {
        title: "Framing paling menipu yang pernah kamu temuin?",
        body: "Di iklan atau berita? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["loss-aversion", "appeal-to-emotion", "cherry-picking", "decoy-effect"],
  };
